/**
 * GoogleクローラのUserAgentマッチパターン
 * @see https://developers.google.com/search/docs/advanced/crawling/overview-google-crawlers?hl=ja
 */
export const GOOGLE_CRAWLER_UA_PATTERN =
  /APIs-Google|AdsBot-Google-Mobile|AdsBot-Google|Googlebot|Mediapartners-Google|AdsBot-Google-Mobile-Apps|FeedFetcher-Google|Google-Read-Aloud|DuplexWeb-Google|Google Favicon|googleweblight|Storebot-Google/;

/** TDのクエリ */
export const TD_QUERY_PARAMETER = 'td_seg';
